import React from 'react';
import styles from './selection-option.module.css';

const icons = {
  boxInsert: `<img src="${window.giftWrapData.insertsAndCards.images.insertImageTextThumbnail}" alt="Box Insert with Text and Image" />`,
  greetingsCard: `<img src="${window.giftWrapData.insertsAndCards.images.greetingsCardImageTextThumbnail}" alt="Greetings Card with Image and Text" />`,
  boxInsertTextOnly: `<img src="${window.giftWrapData.insertsAndCards.images.insertTextThumbnail}" alt="Box Insert with Text" />`,
  greetingsCardTextOnly: `<img src="${window.giftWrapData.insertsAndCards.images.greetingsCardTextThumbnail}" alt="Greetings Card with Text" />`,
  greetingsCardPredesigned: `<img src="${window.giftWrapData.insertsAndCards.images.greetingsCardPredesignedThumbnail}" alt="Greetings Card with Pre-designed Message" />`,
  skip: '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#ffc1a8"><path d="M312-265.33 265.33-312l168-168-168-167L312-693.67l168 168 167-168L693.67-647l-168 167 168 168L647-265.33l-167-168-168 168Z"/></svg>',
  image:
    '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#ffc1a8"><path d="M480-480ZM186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h350v66.67h-350v586.66h586.66v-350H840v350q0 27-19.83 46.84Q800.33-120 773.33-120H186.67ZM240-281.33h480L574-476 449.33-311.33 356.67-434 240-281.33Zm448.67-322V-688h-85.34v-66.67h85.34V-840h66.66v85.33H840V-688h-84.67v84.67h-66.66Z"/></svg>',
  pencil:
    '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#ffc1a8"><path d="M186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h389L509-773.33H186.67v586.66h586.66v-324.66L840-578v391.33q0 27-19.83 46.84Q800.33-120 773.33-120H186.67ZM480-480ZM360-360v-170l377-377q10-10 22.33-14.67 12.34-4.66 24.67-4.66 12.67 0 25.04 5 12.38 5 22.63 15l74 75q9.4 9.97 14.53 22.02 5.13 12.05 5.13 24.51 0 12.47-4.83 24.97-4.83 12.5-14.83 22.5L530-360H360Zm499-424.67-74.67-74.66L859-784.67Zm-432.33 358H502l246-246L710-710l-38.33-37.33-245 244.33v76.33ZM710-710l-38.33-37.33L710-710l38 37.33L710-710Z"/></svg>',
  gallery:
    '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#ffc1a8"><path d="M154.33-152.67 127.67-162Q96-175.67 84.83-209q-11.16-33.33 5.5-65.67l64-142.66v264.66Zm177.34 81.34q-33.67 0-57.5-23.84-23.84-23.83-23.84-57.5v-218L347-98q2.33 7.67 6 13.83 3.67 6.17 9.33 12.84h-30.66Zm194-17.34q-24.67 10-50-3.66-25.34-13.67-36-39.67L253-640.67q-10.67-26 2-50.83t40-35.17L607.67-840q26-9.33 50.66 3.67 24.67 13 35.34 39.66L880.33-292q8.67 27.33-2.66 53.5-11.34 26.17-38.67 35.83l-313.33 114Zm-83.34-488.66q13.67 0 23.5-9.84 9.84-9.83 9.84-23.5 0-13.66-9.84-23.5Q456-644 442.33-644q-13.66 0-23.5 9.83-9.83 9.84-9.83 23.5 0 13.67 9.83 23.5 9.84 9.84 23.5 9.84Zm61.34 424.66 312.66-114L629.67-776 317-662.67l186.67 510ZM317-662.67 629.67-776 317-662.67Z"/></svg>',
  textCard:
    '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#ffc1a8"><path d="M206.67-286.67h546.66v-66.66H206.67v66.66Zm0-160h546.66v-66.66H206.67v66.66Zm0-160H592v-66.66H206.67v66.66Zm-60 446.67q-27 0-46.84-19.83Q80-199.67 80-226.67v-506.66q0-27 19.83-46.84Q119.67-800 146.67-800h666.66q27 0 46.84 19.83Q880-760.33 880-733.33v506.66q0 27-19.83 46.84Q840.33-160 813.33-160H146.67Zm0-66.67h666.66v-506.66H146.67v506.66Zm0 0v-506.66 506.66Z"/></svg>',
  blankCard:
    '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#ffc1a8"><path d="M293.33-213.33h373.34v-533.34H293.33v533.34ZM800-146.67q0 27-19.83 46.84Q760.33-80 733.33-80H226.67q-27 0-46.84-19.83Q160-119.67 160-146.67v-666.66q0-27 19.83-46.84Q199.67-880 226.67-880h506.66q27 0 46.84 19.83Q800-840.33 800-813.33v666.66Zm-66.67 0v-666.66H226.67v666.66h506.66Zm0-666.66H226.67h506.66Z"/></svg>'
};

/**
 * SelectionOption component displays a selectable option with icon, title, and subtitle.
 * Navigation is now handled by the parent component or footer buttons, not here.
 *
 * @param {Object} props - Component props.
 * @param {string} props.icon - The icon/emoji to display.
 * @param {string} props.title - The option title.
 * @param {string | undefined} [props.subtitle] - Optional subtitle text (can include price).
 * @param {boolean} props.isSelected - Whether this option is selected.
 * @param {() => void} props.onClick - Click handler for selection.
 * @param {string | undefined} [props.clicksTo] - Optional page name (for backwards compatibility, not used for navigation).
 * @param {boolean} [props.disabled] - Whether the option is disabled.
 * @returns {import('react').JSX.Element}
 */
export function SelectionOption({
  icon,
  title,
  subtitle,
  isSelected,
  onClick,
  clicksTo = undefined,
  disabled = false
}) {
  /**
   * Handles click event.
   * @returns {void}
   */
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  /**
   * Handles keyboard event.
   * @param {React.KeyboardEvent} e - Keyboard event.
   * @returns {void}
   */
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!disabled) {
        onClick();
      }
    }
  };

  return (
    <div
      className={`${styles.selectionOption} ${isSelected ? styles['selectionOption--selected'] : ''} ${disabled ? styles['selectionOption--disabled'] : ''}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      aria-pressed={isSelected}
    >
      {isSelected && (
        <span className={styles.selectionOption__checkmark}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 3L4.5 9L2 6.5"
              stroke="var(--color-white)"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}

      {icon && <div className={styles.selectionOption__icon} dangerouslySetInnerHTML={{ __html: icons[icon] }} />}

      <div className={styles.selectionOption__content}>
        <h3 className={styles.selectionOption__title}>{title}</h3>
        {subtitle && <p className={styles.selectionOption__subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
}
